import { Component, OnInit } from "@angular/core";
import { mainTransition } from "../animations";
import { UserService } from "@app/services/user.service";
import { Angulartics2GoogleAnalytics } from "angulartics2";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "main",
  template: `
    <section
      [style.backgroundColor]="isEmbed ? '#fbfbfb' : '#3e3e3e'"
      [@mainTransition]="getState(mainOutlet)"
    >
      <router-outlet #mainOutlet="outlet"></router-outlet>
    </section>
    <p-toast position="bottom-center" [baseZIndex]="100001"></p-toast>
    <messenger></messenger>
  `,
  animations: [mainTransition],
})
export class MainComponent implements OnInit {
  isEmbed: boolean;
  constructor(
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private userService: UserService,
    library: FaIconLibrary,
    private route: ActivatedRoute
  ) {
    angulartics2GoogleAnalytics.startTracking();
    library.addIcons(faSearch, faSpinner);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const embedParam = params.embed;
      this.isEmbed = embedParam === "1";
    });
    this.userService.me().then((user) => {
      (<any>window).clarity && (<any>window).clarity("identify", user.email);
    });
  }

  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
}
